import { useToast as useToastContext } from './useToast';
import type { ToastType } from '../contexts/toast-context';

/**
 * Convenience wrapper that returns a `toast()` function matching
 * the { title, description?, variant? } pattern used by shadcn.
 */
export function useToastHelper() {
  const { addToast } = useToastContext();

  const toast = ({
    title,
    description,
    variant,
  }: {
    title: string;
    description?: string;
    variant?: 'default' | 'destructive';
  }) => {
    const type: ToastType = variant === 'destructive' ? 'error' : 'success';
    const message = description ? `${title}: ${description}` : title;
    addToast(type, message);
  };

  return { toast };
}
